var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapbox"},[_c('div',{staticClass:"bg-image"},[_c('div',{staticClass:"map-charts",attrs:{"id":"priceChart"}})])])
}]

export { render, staticRenderFns }